import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

interface IMessage {
  message: string;
}

@Component({
  selector: 'app-loading-snak-bar',
  templateUrl: './loading-snak-bar.component.html',
  styleUrls: ['./loading-snak-bar.component.scss'],
  standalone: false
})
export class LoadingSnakBarComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: IMessage) {}
}
